import { render, staticRenderFns } from "./SrFilterLabel.vue?vue&type=template&id=0ceea2b3"
import script from "./SrFilterLabel.vue?vue&type=script&lang=js"
export * from "./SrFilterLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports